export function formatPrice(value) {
  let valueToFormat

  if (value) {
    valueToFormat = value
  } else {
    valueToFormat = 0
  }

  const valueFormatted = valueToFormat.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  })

  return valueFormatted
}
